<template>
  <div class="border-white border-2 overflow-hidden shadow-md rounded-xl">
    <p
      class="font-semibold text-gray-800 tracking-widest justify-center bg-gradient-to-b from-gray-50 p-2 text-left border-b"
    >
      Knead Anything
    </p>
    <div
      class="bg-white text-left space-y-2 p-2 rounded-b-xl text-sm overflow-hidden"
    >
      <p class="flex space-x-2 items-center">
        <span class="font-semibold text-gray-500">Call: </span
        ><span class="flex-1"
          >{{ $store.state.phone1 }}, {{ $store.state.phone2 }}</span
        >
      </p>
      <p class="flex space-x-2 items-center">
        <span class="font-semibold text-gray-500">Email: </span>
        <span class="flex-1">{{ $store.state.email }}</span>
      </p>
      <p class="flex space-x-2 items-start">
        <span class="font-semibold text-gray-500">Visit Us: </span>
        <span class="flex-1">{{ $store.state.bandbAddress }} </span>
      </p>
    </div>
  </div>
</template>
